import React, { useState, useEffect, createContext, useReducer } from "react";
import { getAnalytics, logEvent } from "firebase/analytics";
import analytics from "./analytics";

// api services
import { BusinessChallengeService, LoyaltyService } from "../services/";

import { useAuth, useSubscriber, useTrivia } from "../hooks";
import { async } from "regenerator-runtime";
import { initialState, reducer } from "../reducers/speedShoppingReducer";
import useTimer from "../hooks/useTimer";
import useFastestFinger from "../hooks/useFastestFinger";

const LoyaltyContext = createContext({});

const Provider = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialState);
  const { phoneNumber } = useAuth();
  const timerFunc = useTimer(30000);

  const [captureAndShareData, setCaptureAndShareData] = useState(null);
  const [captureImage, setCaptureImage] = useState(null);
  const [capture, setCapture] = useState(false);
  const [loyaltyOffersData, setLoyaltyOffersData] = useState(null);
  const [eventOffersData, setEventOffersData] = useState([]);
  const [whatsHappeningData, setWhatsHappeningData] = useState([]);
  const [promoOffersData, setPromoOffersData] = useState([]);
  const [mashupCard, setMashupCard] = useState([]);
  const [loyaltyItem, setLoyaltyItem] = useState(null);
  const [redemptionVendorData, setRedemptionVendorData] = useState([]);
  const [selectedLoyaltyData, setSelectedLoyaltyData] = useState(null);
  const [hasToday, setHasToday] = useState(true);
  const [promoEnd, setPromoEnd] = useState(false);
  const [captureEntries, setCaptureEntries] = useState();
  const [activatedOffers, setActivatedOffers] = useState(null);
  const [loyaltyCheckCode, setLoyaltyCheckCode] = useState(null);
  const [loading, setLoading] = useState(false);
  const [loyaltySuccessMessage, setLoyaltySuccessMessage] = useState("");
  const [loyaltySuccessHeader, setLoyaltySuccessHeader] = useState("Success!");
  const [generationComplete, setGenerationComplete] = useState(false);
  const [generatedCode, setGeneratedCode] = useState(false);
  const [events, setEvents] = useState([]);
  const [inCarousel, setInCarousel] = useState([]);
  const [eventBanner, setEventBanner] = useState(null);
  const [eventText, setEventText] = useState("");
  const [eventTitle, setEventTitle] = useState("");
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [qnABanner, setQnABanner] = useState(null);
  const [qnATitle, setQnATitle] = useState("");
  const [commentsArray, setCommentsArray] = useState([]);
  const [askCommentSubmitted, setAskCommentSubmitted] = useState(false);
  const [movieListData, setMovieListData] = useState(null);
  const [selectedMovie, setSelectedMovie] = useState(null);
  const [voteSubmitted, setVoteSubmitted] = useState(false);
  const [voted, setVoted] = useState(false);
  const [votingEnd, setVotingEnd] = useState(false);
  const [ticketCode, setTicketCode] = useState(null);
  const [ticketGenerated, setTicketGenerated] = useState(false);
  const [movieManiaRedemptionStatus, setMovieManiaRedemptionsStatus] =
    useState(false);
  const [movieManiaRedemptionHistoryData, setMovieManiaRedemptionHistoryData] =
    useState(false);
  const [newFeatureRatings, setNewFeatureRatings] = useState(null);
  const [ticketGenerationErrorMessage, setTicketGenerationErrorMessage] =
    useState(null);
  const [movieManiaStatus, setMovieManiaStatus] = useState(null);
  const [dishrackRedemptionStatus, setDishrackRedemptionsStatus] =
    useState(false);
  const [dishrackCodeGenerationMessage, setDishrackCodeGenerationMessage] =
    useState(null);
  const [dishrackRedemptionHistoryData, setDishrackRedemptionHistoryData] =
    useState(false);
  const [dishrackStatus, setDishrackStatus] = useState(null);
  const [isProcessingDishrack, setIsProcessingDishrack] = useState(false);

  const [potbellyRedemptionStatus, setPotbellyRedemptionsStatus] =
    useState(false);
  const [potbellyCodeGenerationMessage, setPotbellyCodeGenerationMessage] =
    useState(null);
  const [potbellyRedemptionHistoryData, setPotbellyRedemptionHistoryData] =
    useState(false);
  const [potbellyStatus, setPotbellyStatus] = useState(null);
  const [isProcessingPotbelly, setIsProcessingPotbelly] = useState(false);
  const [businessChallengeVotingDetails, setBusinessChallengeVotingDetails] =
    useState();

  const [mashupnWinOrders, setMashupnWinOrders] = useState([]);
  const [userPoints, setUserPoints] = useState({
    pointsRounded: -1,
    historyRounded: [],
    msisdn: "",
    rank: 0,
  });
  const [ypycStatus, setYPYCStatus] = useState({});
  const [ypycRegistrationStatus, setYPYCRegistrationStatus] = useState(null);
  const [offerModal, setOfferModal] = useState(null);
  const [speedShoppingData, setSpeedShoppingData] = useState({});
  const [shoppingCartSaveStatus, setSaveShoppingCartStatus] = useState({});
  const [ticketExpiryMemo, setTicketExpiryMemo] = useState(false);
  const [movieManiaEligibility, setMovieManiaEligibility] = useState(null);
  const [topLoyaltyList, setTopLoyaltyList] = useState([]);
  const [wonItemForPickup, setWonItemForPickup] = useState({});
  const [hasTodayLoading, setHasTodayLoading] = useState(true);
  const [orderStatus, setOrderStatus] = useState("pending");
  const [loyaltyGames, setLoyaltyGames] = useState(null);

  const [fullPickupLocation, setFullPickupLocation] = useState(0);
  const [newInteractions, setNewInteractions] = useState();
  const [hasOptedIn, setHasOptedIn] = useState(true);
  const [captureStatus, setCaptureStatus] = useState();
  const [capturedEntryId, setCapturedEntryId] = useState();

  const { getTrivia, getHistory } = useTrivia();
  const { getFastestFinger } = useFastestFinger();
  const {
    getPhoneNumberFromStorage,
    getUserDetailsFromStorage,
    getFullUserInfoFromStorage,
    fetchUserProfile,
  } = useSubscriber();

  const init = () => {
    fetchLoyalty()
      .then(() => fetchEvents())
      .then(() => getVotingDetails())
      .then(() => getTrivia())
      .then(() => getHistory())
      .then(() => getMovieList())
      .then(() => getPhoneNumberFromStorage())
      .then(() => getUserDetailsFromStorage())
      .then(() => getFullUserInfoFromStorage())
      .then(() => getFastestFinger())
      .then(() => checkMovieManiaStatus())
      .then(() => getActiveFeatureRatings())
      .then(() => fetchUserProfile())
    const token = JSON.parse(localStorage.getItem("token"));
    LoyaltyService.webLogin(token);
  }

  useEffect(() => {
    init();
    getInteractions();
  }, []);


  return (
    <LoyaltyContext.Provider
      value={{
        inCarousel,
        getTopLoyaltyList,
        topLoyaltyList,
        getLoyaltyPoints,
        fetchLoyalty,
        captureAndShareData,
        captureImage,
        setCaptureImage,
        capture,
        setCapture,
        loyaltyOffersData,
        eventOffersData,
        promoOffersData,
        redemptionVendorData,
        whatsHappeningData,
        mashupCard,
        loyaltyItem,
        setLoyaltyItem,
        getPromoOfferFromStorage,
        selectedLoyaltyData,
        setSelectedLoyaltyData,
        getLoyaltyOffersFromStorage,
        generateCoupon,
        fetchCaptureShare,
        saveCaptureShare,
        hasToday,
        promoEnd,
        captureEntries,
        captureStatus,
        loyaltyCheckCode,
        checkOffers,
        activatedOffers,
        loyaltySuccessMessage,
        loyaltySuccessHeader,
        generationComplete,
        setGenerationComplete,
        generatedCode,
        setGeneratedCode,
        fetchEvents,
        events,
        eventBanner,
        eventText,
        eventTitle,
        setSelectedEvent,
        selectedEvent,
        qnABanner,
        qnATitle,
        fetchPreviousLiveComments,
        commentsArray,
        setCommentsArray,
        submitLiveComment,
        askQuestion,
        askCommentSubmitted,
        movieListData,
        setSelectedMovie,
        selectedMovie,
        submitVote,
        voted,
        setVoted,
        getMovieList,
        setVotingEnd,
        votingEnd,
        reserveTicket,
        ticketCode,
        loading,
        setLoading,
        hasOptedIn,
        setHasOptedIn,
        submitOptInStatus,

        // Movie Mania
        ticketGenerated,
        setTicketGenerated,
        redeemMovieManiaTicket,
        setMovieManiaRedemptionsStatus,
        movieManiaRedemptionStatus,
        movieManiaStatus,
        fetchMovieManiaRedemptionHistory,
        movieManiaRedemptionHistoryData,
        checkMovieManiaStatus,

        // Dishrack
        checkDishrackStatus,
        reserveDishrackCode,
        setDishrackRedemptionsStatus,
        dishrackRedemptionStatus,
        dishrackCodeGenerationMessage,
        setDishrackCodeGenerationMessage,
        dishrackStatus,
        isProcessingDishrack,
        redeemDishrackTicket,
        dishrackRedemptionHistoryData,
        fetchDishrackRedemptionHistory,

        // Potbelly
        checkPotbellyStatus,
        reservePotbellyCode,
        redeemPotbellyTicket,
        potbellyStatus,
        setPotbellyRedemptionsStatus,
        potbellyRedemptionStatus,
        potbellyCodeGenerationMessage,
        setPotbellyCodeGenerationMessage,
        isProcessingPotbelly,
        potbellyRedemptionHistoryData,
        fetchPotbellyRedemptionHistory,

        // New feature ratings
        newInteractions,
        getInteractions,
        newFeatureRatings,
        hideNewFeatureRatings,
        getActiveFeatureRatings,
        submitFeatureRatings,
        registerYPYC,
        ypycStatus,
        setYPYCStatus,
        ypycRegistrationStatus,
        checkYPYCRegistrationStatus,
        ticketGenerationErrorMessage,
        setMashupnWinOrders,
        mashupnWinOrders,
        userPoints,
        setUserPoints,
        offerModal,
        setOfferModal,
        timerFunc,
        speedShoppingController: {
          state,
          dispatch,
        },
        getSpeedShoppingData,
        speedShoppingData,
        shoppingCartSaveStatus,
        saveShoppingCart,
        ticketExpiryMemo,
        setTicketExpiryMemo,
        movieManiaEligibility,
        updateUserLocation,
        checkMovieManiaEligibility,
        saveCapturePickupLocation,
        wonItemForPickup,
        setWonItemForPickup,
        fullPickupLocation,
        setFullPickupLocation,
        hasTodayLoading,
        orderStatus,
        loyaltyGames,

        // Business challenge
        businessChallengeVotingDetails,
        getVotingDetails,
      }}
    >
      {children}
    </LoyaltyContext.Provider>
  );

  async function fetchLoyalty() {
    try {
      const token = JSON.parse(localStorage.getItem("token"));
      const { data, success } = await LoyaltyService.fetchLoyaltyOffers(token);

      if (success) {
        const { loyaltyCheckCode } = data;
        setLoyaltyCheckCode(loyaltyCheckCode);

        const { offers, redemptionPortals, hasOptedIn } = data || null;
        setHasOptedIn(hasOptedIn);
        if (offers) {
          const loyaltyOffers = data?.offers?.filter((data) => data.isLoyalty);
          const eventOffers = data?.offers?.filter((data) => data.isEvent);
          const promoOffers = data?.offers?.filter((data) => data.isPromo);
          const mashupOffers = data?.offers?.filter((data) => data.isMashup);
          const loyaltyGames = data?.offers?.filter((data) => data.isGame);
          const inCarousel = data?.offers?.filter((data) => data.carouselImage);
          const captureShare = data?.offers?.filter(
            (data) => data.isCaptureShare
          );
          const whatsHappeningOffers = data?.offers
            ?.filter((data) => data.whatsHappeningOrder)
            .sort((a, b) => a.whatsHappeningOrder - b.whatsHappeningOrder);

          setCaptureAndShareData(captureShare[0]);

          setOrderStatus(captureShare[0].promoData.orderStatus);
          setLoyaltyOffersData(loyaltyOffers);
          setEventOffersData(eventOffers);
          setPromoOffersData(promoOffers);
          setMashupCard(mashupOffers);
          setWhatsHappeningData(whatsHappeningOffers);
          setRedemptionVendorData(redemptionPortals || []);
          setInCarousel(inCarousel);
          setLoyaltyGames(loyaltyGames);

          //saving to the local storage
          localStorage.setItem(
            "loyaltyOffersData",
            JSON.stringify(loyaltyOffers)
          );
          localStorage.setItem("eventOffersData", JSON.stringify(eventOffers));
          localStorage.setItem("promoOffersData", JSON.stringify(promoOffers));
          localStorage.setItem("mashupCard", JSON.stringify(mashupOffers));
        }
      }
    } catch (e) { }
  }

  async function getLoyaltyOffersFromStorage() {
    try {
      const data = JSON.parse(localStorage.getItem("loyaltyOffersData"));
      if (data) {
        setLoyaltyOffersData(data);
      }
      return;
    } catch (e) { }
  }

  async function getPromoOfferFromStorage() {
    try {
      const data = JSON.parse(localStorage.getItem("promoOffersData"));
      const refinedData = data.filter((item) => item.isCaptureShare);
      if (data) {
        setCaptureAndShareData(refinedData[0]);
      }
      return;
    } catch (e) { }
  }

  async function generateCoupon(input) {
    try {
      // setLoading(true);
      const token = JSON.parse(localStorage.getItem("token"));
      const { data, success } = await LoyaltyService.generateCoupon(
        input,
        phoneNumber,
        token
      );

      const hour = new Date().getHours();
      const day = new Date().getDay();

      const days = [
        "sunday",
        "monday",
        "tuesday",
        "wednesday",
        "thursday",
        "friday",
        "saturday",
      ];

      // setLoading(false);
      setGenerationComplete(true);
      const { offer } = data || {};
      if (success) {
        analytics().then((anl) =>
          logEvent(anl, "vendor_loyalty_generation", {
            vendor: input,
            result: "success",
            generation_day: days[day],
            generation_hour: hour,
          })
        );

        setGeneratedCode(true);
        setLoyaltySuccessMessage(offer);
      } else if (success == false) {
        analytics().then((anl) =>
          logEvent(anl, "vendor_loyalty_generation", {
            vendor: input,
            result: "false",
            generation_day: days[day],
            generation_hour: hour,
          })
        );

        setLoyaltySuccessHeader("Oops...");
        setLoyaltySuccessMessage(offer);
      }
    } catch (e) { }
  }

  async function checkOffers(input) {
    try {
      const token = JSON.parse(localStorage.getItem("token"));
      const gps = JSON.parse(localStorage.getItem("gps"));

      const { data, success, message } = await LoyaltyService.checkOffers(
        input,
        `233${phoneNumber?.substring(1)}`,
        token,
        gps
      );
      if (success) {
        const { offers } = data;

        setActivatedOffers(offers);
      }
    } catch (e) { }
  }

  async function fetchCaptureShare(code) {
    try {
      const token = JSON.parse(localStorage.getItem("token"));

      setHasTodayLoading(true);

      const { data, success } = await LoyaltyService.fetchCaptureShare(
        phoneNumber,
        code,
        token
      );

      if (success) {
        const { entries, hasToday, promoEnd } = data || {};

        setCaptureEntries(entries);
        setHasToday(hasToday);
        setPromoEnd(promoEnd);

        setHasTodayLoading(false);
      }
    } catch (e) {
      setHasTodayLoading(false);
    }
  }

  async function submitOptInStatus(hasOptedIn) {
    try {
      const token = JSON.parse(localStorage.getItem("token"));
      await LoyaltyService.updateOptInStatus(token, { hasOptedIn });
    } catch (e) {
      console.log(e);
    }
  }

  async function saveCaptureShare(payload, code) {
    setCaptureStatus(null);
    try {
      const token = JSON.parse(localStorage.getItem("token"));

      const { data, success } = await LoyaltyService.saveCaptureShare(
        payload,
        token
      );

      if (success) {
        analytics().then((anl) =>
          logEvent(anl, "capture_submitted", {
            code: code,
            result: "true",
            payload,
          })
        );
        setCaptureStatus("success");
        setCapturedEntryId(data._id)
      }
    } catch (e) {
      const { error } = e.response?.data || {};
      if (error == "Item out of stock") {
        setCaptureStatus("OUT_OF_STOCK")
      }
    }
  }

  async function fetchEvents() {
    try {
      const token = JSON.parse(localStorage.getItem("token"));
      const { data, success } = await LoyaltyService.fetchEvents(token);

      if (success) {
        const {
          eventBanner,
          eventText,
          eventTitle,
          events,
          qaBanner,
          qaTitle,
        } = data;
        setEventBanner(eventBanner);
        setEventText(eventText);
        setEventTitle(eventTitle);
        setEvents(events);
        setQnABanner(qaBanner);
        setQnATitle(qaTitle);
      }
    } catch (e) { }
  }

  async function fetchPreviousLiveComments(id) {
    try {
      const token = JSON.parse(localStorage.getItem("token"));
      const { data, success } = await LoyaltyService.getPreviousLiveComments(
        token,
        id
      );

      if (success) {
        setCommentsArray(data);
      }
    } catch (e) { }
  }

  async function submitLiveComment(payload) {
    try {
      const token = JSON.parse(localStorage.getItem("token"));
      const { data } = await LoyaltyService.submitLiveComment(token, payload);
    } catch (e) { }
  }

  async function askQuestion(payload) {
    try {
      const token = JSON.parse(localStorage.getItem("token"));
      const { data, success } = await LoyaltyService.askQuestion(
        token,
        payload
      );
      if (success) {
        analytics().then((anl) =>
          logEvent(anl, "question_submitted", {
            result: "true",
            payload,
          })
        );
        setAskCommentSubmitted(success);
      }
    } catch (e) { }
  }

  async function getMovieList() {
    try {
      const token = JSON.parse(localStorage.getItem("token"));

      const { data, success } = await LoyaltyService.fetchMovieList(token);
      if (success) {
        setMovieListData(data);
      }
    } catch (e) { }
  }

  async function submitVote(id) {
    try {
      const token = JSON.parse(localStorage.getItem("token"));
      const { vote, success } = await LoyaltyService.Vote(token, id);
      if (success) {
        analytics().then((anl) =>
          logEvent(anl, "submit_vote", {
            id,
          })
        );
        setVoteSubmitted(success);
      }
    } catch (e) { }
  }

  async function reserveTicket(code) {
    try {
      setLoading(true);
      const token = JSON.parse(localStorage.getItem("token"));
      const { data, success, message } = await LoyaltyService.reserveTicket(
        token,
        code
      );
      if (success) {
        analytics().then((anl) => logEvent(anl, "reserve_ticket"));
        setTicketGenerated(true);
        setTicketCode(data?.ticketCode);
      } else {
        setTicketGenerationErrorMessage(
          message || "Sorry, an error occurred while generating your ticket."
        );
      }
      setLoading(false);
    } catch (e) { }
  }

  async function getActiveFeatureRatings() {
    try {
      const token = JSON.parse(localStorage.getItem("token"));
      const { data, success } = await LoyaltyService.fetchActiveFeatureRatings(
        token
      );
      if (success) {
        setNewFeatureRatings(
          newFeatureRatings ? { ...newFeatureRatings, ...data } : data
        );
      }
    } catch (e) { }
  }

  async function getInteractions() {
    try {
      const token = JSON.parse(localStorage.getItem("token"));
      const data = await LoyaltyService.fetchInteractions(token);
      setNewInteractions(data);
    } catch (e) { }
  }

  async function submitFeatureRatings({
    feature,
    feedbackExperience,
    feedbackMessage,
  }) {
    try {
      const token = JSON.parse(localStorage.getItem("token"));
      const { success } = await LoyaltyService.submitFeatureRatings(token, {
        feature,
        feedbackExperience,
        feedbackMessage,
      });
      if (success) {
        // Done
      }
    } catch (e) { }
  }

  function hideNewFeatureRatings() {
    setNewFeatureRatings({ ...newFeatureRatings, isSeen: true });
  }

  async function redeemMovieManiaTicket(code, location) {
    try {
      setLoading(true);
      const token = JSON.parse(localStorage.getItem("token"));
      const data = await LoyaltyService.redeemMovieManiaTicket(
        token,
        code,
        location
      );
      setMovieManiaRedemptionsStatus(data);
    } catch (e) {
      setMovieManiaRedemptionsStatus({
        success: false,
        message: "An error occurred",
      });
    } finally {
      setLoading(false);
    }
  }

  async function redeemDishrackTicket(code, location) {
    try {
      setLoading(true);
      const token = JSON.parse(localStorage.getItem("token"));
      const data = await LoyaltyService.redeemDishrackTicket(
        token,
        code,
        location
      );
      setDishrackRedemptionsStatus(data);
    } catch (e) {
      setDishrackStatus({ success: false, message: "An error occurred" });
    } finally {
      setLoading(false);
    }
  }

  async function redeemPotbellyTicket(code, location) {
    try {
      setLoading(true);
      const token = JSON.parse(localStorage.getItem("token"));
      const data = await LoyaltyService.redeemPotbellyTicket(
        token,
        code,
        location
      );
      setPotbellyRedemptionsStatus(data);
    } catch (e) {
      setPotbellyStatus({ success: false, message: "An error occurred" });
    } finally {
      setLoading(false);
    }
  }

  async function fetchMovieManiaRedemptionHistory() {
    try {
      setLoading(true);
      const token = JSON.parse(localStorage.getItem("token"));
      const data = await LoyaltyService.fetchMovieManiaRedemptionHistory(token);
      setMovieManiaRedemptionHistoryData(data);
    } catch (e) {
      setMovieManiaRedemptionHistoryData({
        success: false,
        message: "An error occurred",
      });
    } finally {
      setLoading(false);
    }
  }

  async function fetchDishrackRedemptionHistory() {
    try {
      setLoading(true);
      const token = JSON.parse(localStorage.getItem("token"));
      const data = await LoyaltyService.fetchDishrackRedemptionHistory(token);
      setDishrackRedemptionHistoryData(data);
    } catch (e) {
      setDishrackRedemptionHistoryData({
        success: false,
        message: "An error occurred",
      });
    } finally {
      setLoading(false);
    }
  }

  async function fetchPotbellyRedemptionHistory() {
    try {
      setLoading(true);
      const token = JSON.parse(localStorage.getItem("token"));
      const data = await LoyaltyService.fetchPotbellyRedemptionHistory(token);
      setPotbellyRedemptionHistoryData(data);
    } catch (e) {
      setPotbellyRedemptionHistoryData({
        success: false,
        message: "An error occurred",
      });
    } finally {
      setLoading(false);
    }
  }

  async function registerYPYC(payload) {
    try {
      setYPYCStatus({
        ...ypycStatus,
        loading: true,
      });
      const token = JSON.parse(localStorage.getItem("token"));
      const { success } = await LoyaltyService.submitYPYCForm(token, payload);
      setYPYCStatus({
        ...ypycStatus,
        success,
        loading: false,
      });
      setYPYCRegistrationStatus(null);
    } catch (e) {
      setYPYCStatus({
        ...ypycStatus,
        message:
          e?.response?.status === 409
            ? "You have already registered. Multiple registration not allowed"
            : "Sorry, an error occured",
        success: false,
        loading: false,
      });
    }
  }

  async function checkYPYCRegistrationStatus() {
    try {
      const token = JSON.parse(localStorage.getItem("token"));
      const {
        data: { isRegistered },
      } = await LoyaltyService.checkYPYCRegistrationStatus(token);
      setYPYCRegistrationStatus(isRegistered);
    } catch (e) {
      setYPYCRegistrationStatus(false);
    }
  }

  async function checkMovieManiaStatus() {
    try {
      const token = JSON.parse(localStorage.getItem("token"));
      const {
        data: { status },
      } = await LoyaltyService.checkMovieManiaStatus(token);
      setMovieManiaStatus(status);
    } catch (e) {
      setMovieManiaStatus({
        active: false,
      });
    }
  }

  async function reserveDishrackCode() {
    try {
      setIsProcessingDishrack(true);
      const token = JSON.parse(localStorage.getItem("token"));
      const { data } = await LoyaltyService.reserveDishrackCode(token);
      setDishrackStatus(data || { success: false });
      setDishrackCodeGenerationMessage({
        success: true,
        ticketCode: data.ticketCode,
      });
    } catch (e) {
      setDishrackCodeGenerationMessage({
        success: false,
      });
    } finally {
      setIsProcessingDishrack(false);
    }
  }

  async function checkDishrackStatus() {
    try {
      const token = JSON.parse(localStorage.getItem("token"));
      const { data } = await LoyaltyService.checkDishrackStatus(token);
      setDishrackStatus(data || { success: false });
    } catch (e) {
      setDishrackStatus({
        error: true,
        success: false,
      });
    }
  }

  async function reservePotbellyCode() {
    try {
      setIsProcessingPotbelly(true);
      const token = JSON.parse(localStorage.getItem("token"));
      const { data } = await LoyaltyService.reservePotbellyCode(token);
      setPotbellyStatus(data || { success: false });
      setPotbellyCodeGenerationMessage({
        success: true,
        ticketCode: data.ticketCode,
      });
    } catch (e) {
      setPotbellyCodeGenerationMessage({
        success: false,
      });
    } finally {
      setIsProcessingPotbelly(false);
    }
  }

  async function checkPotbellyStatus() {
    try {
      const token = JSON.parse(localStorage.getItem("token"));
      const { data } = await LoyaltyService.checkPotbellyStatus(token);
      setPotbellyStatus(data || { success: false });
    } catch (e) {
      setPotbellyStatus({
        error: true,
        success: false,
      });
    }
  }

  async function getSpeedShoppingData() {
    setSpeedShoppingData({
      isLoading: true,
    });
    try {
      const token = JSON.parse(localStorage.getItem("token"));
      const data = await LoyaltyService.getSpeedShoppingData(token);
      const { shoppingItems } = data;
      dispatch({ type: "setItems", items: shoppingItems });
      setSpeedShoppingData({
        isLoading: false,
        ...data,
      });
    } catch (e) {
      setSpeedShoppingData({
        isLoading: false,
        error: true,
      });
    }
  }

  async function saveShoppingCart(payload) {
    setSaveShoppingCartStatus({
      isLoading: true,
      error: true,
    });
    try {
      const token = JSON.parse(localStorage.getItem("token"));
      const { success } = await LoyaltyService.saveShoppingCart(token, payload);
      setSaveShoppingCartStatus({
        isLoading: false,
        success: true,
      });
    } catch (e) {
      setSaveShoppingCartStatus({
        isLoading: false,
        error: true,
      });
    }
  }

  async function checkMovieManiaEligibility(code) {
    try {
      const token = JSON.parse(localStorage.getItem("token"));
      const data = await LoyaltyService.checkMovieManiaEligibility(token, code);
      setMovieManiaEligibility(data);
    } catch (e) { }
  }

  async function updateUserLocation(payload) {
    try {
      const token = JSON.parse(localStorage.getItem("token"));
      const data = await LoyaltyService.updateUserLocation(token, payload);
      setMovieManiaEligibility(data);
    } catch (e) { }
  }

  async function getTopLoyaltyList({ payload }) {
    try {
      const token = JSON.parse(localStorage.getItem("token"));

      const { data } = await LoyaltyService.fetchTopLoyaltyList({
        token,
        payload,
      });

      setTopLoyaltyList(data);
    } catch (e) { }
  }

  async function getLoyaltyPoints({ payload }) {
    try {
      const token = JSON.parse(localStorage.getItem("token"));

      const { data } = await LoyaltyService.fetchLoyaltyPoints({
        token,
        payload,
      });

      setUserPoints(data);
    } catch (e) { }
  }

  async function saveCapturePickupLocation(payload, history) {
    try {
      const token = JSON.parse(localStorage.getItem("token"));

      const { pickup } = payload;

      const { data } = await LoyaltyService.postCapturePickupLocation({
        token,
        _id: capturedEntryId,
        pickup,
      });
      fetchCaptureShare();
      history.push(`/capturenshare/history`)
    } catch (e) { }
  }

  async function getVotingDetails() {
    try {
      const token = JSON.parse(localStorage.getItem("token"));
      const { success, data } = await BusinessChallengeService.getVotingDetails(
        token
      );
      setBusinessChallengeVotingDetails(data);
    } catch (error) { }
  }
};

LoyaltyContext.ProviderWrapper = Provider;

export default LoyaltyContext;
